/* UniCurt unpublished mobile filter layout. No cart, pricing or filter-request code. */
(() => {
  'use strict';
  const VERSION = 'unicurt-mobile-top-filters-v3-singleline-20261030';
  if (window.__ucMobileTopFilters === VERSION) return;
  if (window.Shopify?.theme?.id && String(window.Shopify.theme.id) !== '188133015737') return;
  window.__ucMobileTopFilters = VERSION;
  const media = window.matchMedia('(max-width: 749px)');
  let currentRoot = null;
  let observer = null;
  let scheduled = false;

  const set = (node, name, value) => {
    if (node && node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const restore = (node, attr, saved) => {
    if (saved === null) node.removeAttribute(attr);
    else set(node, attr, saved);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  function preventCollapse(event) {
    if (!media.matches || !currentRoot?.hasAttribute('data-uc-mobile-top')) return;
    const summary = event.target.closest?.('#FacetFiltersFormMobile details > summary');
    if (summary && currentRoot.contains(summary)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  function preventEscapeCollapse(event) {
    if (media.matches && event.key === 'Escape' && event.target.closest?.('#FacetFiltersFormMobile')) {
      event.stopPropagation();
    }
  }
  function selectSwatchText(event) {
    if (!media.matches || !currentRoot?.hasAttribute('data-uc-mobile-top')) return;
    const chip = event.target.closest?.('#FacetFiltersFormMobile div.facet-checkbox');
    if (!chip || event.target.closest('input, label, a, button')) return;
    const checkbox = chip.querySelector('input[type="checkbox"]');
    if (checkbox && !checkbox.disabled) checkbox.click();
  }
  function reflectSelection(event) {
    if (!media.matches || !event.target.matches?.('#FacetFiltersFormMobile input[type="checkbox"]')) return;
    event.target.closest('.facet-checkbox')?.classList.toggle('active', event.target.checked);
  }
  function activate(root) {
    const drawer = root.querySelector('#drawer-filter');
    const form = drawer?.querySelector('#FacetFiltersFormMobile');
    if (!drawer || !form) return;
    if (!drawer._ucInlineState) {
      // Close only this filter drawer if it was opened at a larger viewport.
      if (drawer.hasAttribute('open') && typeof drawer.close === 'function') drawer.close();
      drawer._ucInlineState = {
        role: drawer.getAttribute('role'),
        modal: drawer.getAttribute('aria-modal'),
        hidden: drawer.querySelector('.drawer-content')?.getAttribute('aria-hidden') ?? null
      };
      // The original component registers a document-level Escape handler. An inline
      // region must not act like a modal or unlock/steal focus from another drawer.
      if (typeof drawer.handleKeyPress === 'function') {
        document.removeEventListener('keydown', drawer.handleKeyPress);
      }
    }
    set(root, 'data-uc-mobile-top', VERSION);
    drawer.parentElement.classList.add('uc-mobile-filter-bar');
    const toolbar = Array.from(drawer.parentElement.children).find(child =>
      child !== drawer && child.querySelector("drawer-button[data-target='drawer-filter']")
    );
    toolbar?.classList.add('uc-mobile-filter-toolbar');
    root.closest('.section-collection-products-grid')?.classList.add('uc-mobile-filter-section');
    set(drawer, 'role', 'region');
    drawer.removeAttribute('aria-modal');
    set(drawer.querySelector('.drawer-content'), 'aria-hidden', 'false');

    form.querySelectorAll('details.js-filter').forEach(details => {
      // Hide the Type row on mobile without deleting its inputs, URL state, or
      // desktop configuration. Reapply after the theme replaces facet markup.
      const label = details.querySelector('.facets__summary-label')?.cloneNode(true);
      label?.querySelectorAll('.facets__selected').forEach(count => count.remove());
      const labelText = (label?.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
      const isType = ['type', 'by type', 'product type', 'by product type'].includes(labelText) ||
        !!details.querySelector('input[name="filter.p.product_type"], input[name="filter.p.m.custom.type"]');
      const row = details.closest('collapsible-details') || details;
      if (isType) set(row, 'data-uc-omit-row', 'type');
      else row.removeAttribute('data-uc-omit-row');
      if (!details.hasAttribute('data-uc-initial-open')) {
        // Data attributes survive the existing theme's clone/reinitialization cycle.
        set(details, 'data-uc-initial-open', details.open ? '1' : '0');
        set(details, 'data-uc-initial-class-open', details.classList.contains('is-open') ? '1' : '0');
      }
      if (!details.open) details.open = true;
      if (!details.classList.contains('is-open')) details.classList.add('is-open');
      const summary = details.querySelector(':scope > summary');
      if (summary) {
        if (!summary.hasAttribute('data-uc-summary-state')) {
          set(summary, 'data-uc-summary-state', JSON.stringify({tab: summary.getAttribute('tabindex'), role: summary.getAttribute('role')}));
        }
        set(summary, 'aria-expanded', 'true');
        set(summary, 'aria-disabled', 'true');
        set(summary, 'tabindex', '-1');
      }
    });
  }
  function deactivate(root) {
    const drawer = root.querySelector('#drawer-filter');
    if (!drawer || !root.hasAttribute('data-uc-mobile-top')) return;
    root.removeAttribute('data-uc-mobile-top');
    drawer.parentElement.classList.remove('uc-mobile-filter-bar');
    root.querySelectorAll('.uc-mobile-filter-toolbar').forEach(node => node.classList.remove('uc-mobile-filter-toolbar'));
    root.querySelectorAll('[data-uc-omit-row]').forEach(node => node.removeAttribute('data-uc-omit-row'));
    root.closest('.section-collection-products-grid')?.classList.remove('uc-mobile-filter-section');
    const state = drawer._ucInlineState;
    if (state) {
      restore(drawer, 'role', state.role);
      restore(drawer, 'aria-modal', state.modal);
      const content = drawer.querySelector('.drawer-content');
      if (content) restore(content, 'aria-hidden', state.hidden);
      if (typeof drawer.handleKeyPress === 'function') document.addEventListener('keydown', drawer.handleKeyPress);
      delete drawer._ucInlineState;
    }
    drawer.querySelectorAll('details[data-uc-initial-open]').forEach(details => {
      details.open = details.getAttribute('data-uc-initial-open') === '1';
      details.classList.toggle('is-open', details.getAttribute('data-uc-initial-class-open') === '1');
      details.removeAttribute('data-uc-initial-open');
      details.removeAttribute('data-uc-initial-class-open');
      const summary = details.querySelector(':scope > summary');
      if (summary) {
        try {
          const saved = JSON.parse(summary.getAttribute('data-uc-summary-state') || '{}');
          restore(summary, 'tabindex', saved.tab ?? null);
          restore(summary, 'role', saved.role ?? null);
        } catch (_) { summary.removeAttribute('tabindex'); }
        summary.removeAttribute('data-uc-summary-state');
        summary.removeAttribute('aria-disabled');
        set(summary, 'aria-expanded', String(details.open));
      }
      details.closest('collapsible-details')?.setupInitialState?.();
    });
  }
  function sync() {
    const root = document.getElementById('main-collection-filters');
    if (currentRoot && root !== currentRoot) {
      observer?.disconnect();
      currentRoot.removeEventListener('click', preventCollapse, true);
      currentRoot.removeEventListener('click', selectSwatchText);
      currentRoot.removeEventListener('keyup', preventEscapeCollapse, true);
      currentRoot.removeEventListener('input', reflectSelection);
      currentRoot = null;
    }
    if (!root) return;
    if (root !== currentRoot) {
      currentRoot = root;
      root.addEventListener('click', preventCollapse, true);
      root.addEventListener('click', selectSwatchText);
      root.addEventListener('keyup', preventEscapeCollapse, true);
      root.addEventListener('input', reflectSelection);
      observer = new MutationObserver(schedule);
    }
    observer.disconnect();
    if (media.matches) activate(root);
    else deactivate(root);
    // Observe the filter region only, not the product grid or the rest of the page.
    observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'aria-hidden']});
  }
  media.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once: true});
  else sync();
})();
